import UsersPage from "./UsersPage.page";

export default UsersPage;
